import { temarioNodeHasVisibleContent } from "./campusVisibleContent";

/** @typedef {import("./temarioTree").TemarioNodo} TemarioNodo */

/**
 * @typedef {object} RootFolderSection
 * @property {number} sourceIndex
 * @property {"folder"} kind
 * @property {string} title
 * @property {TemarioNodo} node
 * @property {TemarioNodo} displayNode
 */

/**
 * @param {TemarioNodo | null | undefined} node
 * @param {string} fallback
 * @returns {string}
 */
function nodeTitle(node, fallback) {
  const name = typeof node?.nombre === "string" ? node.nombre.trim() : "";
  return name || fallback;
}

/**
 * One visual container per real root folder, keeping that folder's name and
 * only the files/tests stored on that node. Tests are never renamed or moved
 * into a generic "Test" dump.
 *
 * @param {TemarioNodo[] | null | undefined} nodes
 * @returns {RootFolderSection[]}
 */
export function listRootFolderSections(nodes) {
  const list = Array.isArray(nodes) ? nodes : [];
  return list.map((node, index) => {
    const sourceIndex = Number.isInteger(node?.sourceIndex) ? node.sourceIndex : index;
    const title = nodeTitle(node, `Bloque ${sourceIndex + 1}`);
    return {
      sourceIndex,
      kind: "folder",
      title,
      node,
      displayNode: node,
    };
  });
}

/**
 * Student / preview cards: one card per visible root folder, same names and links.
 * @param {TemarioNodo[] | null | undefined} blocks
 * @returns {Array<{ sourceIndex: number, kind: "folder", title: string, bloque: TemarioNodo }>}
 */
export function expandTemarioBlocksForStudentCards(blocks) {
  return listRootFolderSections(blocks)
    .filter((section) => temarioNodeHasVisibleContent(section.node))
    .map((section) => ({
      sourceIndex: section.sourceIndex,
      kind: section.kind,
      title: section.title,
      bloque: section.node,
    }));
}
